<div class="dx-card wide-card">
    <div class="btndiv">
        <dx-button icon="export" text="Export Charts" type="default" class="exportbtn" (onClick)="exportCharts()">
        </dx-button>
    </div>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
    <div class="content-block">
        <dx-responsive-box singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>

            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>

            <dxi-item>
                <dxi-location [row]="0" [col]="0" [colspan]="2"></dxi-location>
                <h5 style="text-align: center;">Tonnage Business Announcement Capital By Competitor and Region</h5>
                <b class="lblyear" style="text-align: center;">CY{{selectedAnnouncementYear}}</b>
                <h6 style="text-align: center;">{{billionUSDCapitalInvestmentlbl}}</h6>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="1" [col]="0" [colspan]="2"></dxi-location>
                <div>
                    <dx-chart #fullchart [customizePoint]="customizeSidebySideChart" palette="soft" class="width100"
                        id="fullchart" [dataSource]="fullReportDataSource">
                        <dxi-series valueField="euHycoNew" name="HyCO-New" stack="Europe"></dxi-series>
                        <dxi-series valueField="euHycoAcq" name="HyCO-Acquisition" stack="Europe"></dxi-series>
                        <dxi-series valueField="euAsuNew" name="ASU-New" stack="Europe"></dxi-series>
                        <dxi-series valueField="euAsuAcq" name="ASU-Acquisition" stack="Europe"></dxi-series>
                        <dxi-series valueField="euGacifierNew" name="Gasifier-New" stack="Europe"></dxi-series>

                        <dxi-series valueField="asHycoNew" name="HyCO-New" stack="Asia/India"></dxi-series>
                        <dxi-series valueField="asHycoAcq" name="HyCO-Acquisition" stack="Asia/India"></dxi-series>
                        <dxi-series valueField="asAsuNew" name="ASU-New" stack="Asia/India"></dxi-series>
                        <dxi-series valueField="asAsuAcq" name="ASU-Acquisition" stack="Asia/India"></dxi-series>
                        <dxi-series valueField="asGacifierNew" name="Gasifier-New" stack="Asia/India"></dxi-series>

                        <dxi-series valueField="naHycoNew" name="HyCO-New" stack="North America"></dxi-series>
                        <dxi-series valueField="naHycoAcq" name="HyCO-Acquisition" stack="North America"></dxi-series>
                        <dxi-series valueField="naAsuNew" name="ASU-New" stack="North America"></dxi-series>
                        <dxi-series valueField="naAsuAcq" name="ASU-Acquisition" stack="North America"></dxi-series>
                        <dxi-series valueField="naGacifierNew" name="Gasifier-New" stack="North America"></dxi-series>

                        <dxi-series valueField="rowHycoNew" name="HyCO-New" stack="ROW"></dxi-series>
                        <dxi-series valueField="rowHycoAcq" name="HyCO-Acquisition" stack="ROW"></dxi-series>
                        <dxi-series valueField="rowAsuNew" name="ASU-New" stack="ROW"></dxi-series>
                        <dxi-series valueField="rowAsuAcq" name="ASU-Acquisition" stack="ROW"></dxi-series>
                        <dxi-series valueField="rowGacifierNew" name="Gasifier-New" stack="ROW"></dxi-series>

                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltipFullChart">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-legend [customizeItems]="customizeItems" verticalAlignment="top" [visible]="true"
                            horizontalAlignment="center" itemTextPosition="top">
                        </dxo-legend>
                        <dxi-value-axis position="left">
                            <dxo-title text="USD $MM"></dxo-title>
                        </dxi-value-axis>
                        <dxo-common-series-settings argumentField="bigCompetitor" type="stackedBar">
                        </dxo-common-series-settings>
                        <dxo-argument-axis>
                            <dxo-label [visible]="true" template="labelTemplate"></dxo-label>
                        </dxo-argument-axis>
                        <svg overflow="visible" *dxTemplate="let data of 'labelTemplate'">
                            <text class="template-text" text-anchor="start" x="22" y="30">EU</text>
                            <text class="template-text" text-anchor="start" x="45" y="30">AS</text>
                            <text class="template-text" text-anchor="start" x="67" y="30">NA</text>
                            <text class="template-text" text-anchor="start" x="90" y="30">ROW</text>
                            <text class="template-text" x="70" y="60" text-anchor="middle">
                                {{ data.valueText }}
                            </text>
                        </svg>
                        <dxo-export [enabled]="true"></dxo-export>
                        <dxo-tooltip [enabled]="true"></dxo-tooltip>
                    </dx-chart>
                </div>
            </dxi-item>
            <dxi-item class="marginT40">
                <dxi-location [row]="2" [col]="0"></dxi-location>
                <h5 style="text-align: center;">Asia/India</h5>
            </dxi-item>
            <dxi-item class="marginT40">
                <dxi-location [row]="2" [col]="1"></dxi-location>
                <h5 style="text-align: center;">North America</h5>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="3" [col]="0"></dxi-location>
                <dx-chart [customizePoint]="customizePointRegional" palette="soft" class="width100" #asiachart
                    id="asiachart" [dataSource]="asiaDataSource">
                    <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                    <dxo-common-series-settings argumentField="bigCompetitor" valueField="competitorInvestment"
                        type="stackedBar">
                    </dxo-common-series-settings>
                    <dxi-value-axis position="left">
                        <dxo-title text="USD $MM"></dxo-title>
                    </dxi-value-axis>
                    <dxo-argument-axis position="center">
                        <dxo-title text="Competitor"></dxo-title>
                    </dxo-argument-axis>
                    <dxo-legend verticalAlignment="top" [visible]="false" horizontalAlignment="center"
                        itemTextPosition="top">
                    </dxo-legend>
                    <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                        <dxo-format type="thousands" [precision]="1">
                        </dxo-format>
                    </dxo-tooltip>
                    <dxo-series-template nameField="primaryBusinessType"></dxo-series-template>
                    <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                </dx-chart>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="3" [col]="1"></dxi-location>
                <dx-chart [customizePoint]="customizePointRegional" palette="soft" class="width100" #nachart
                    id="nachart" [dataSource]="northAmericaDataSource">
                    <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                    <dxo-common-series-settings argumentField="bigCompetitor" valueField="competitorInvestment"
                        type="stackedBar">
                    </dxo-common-series-settings>
                    <dxi-value-axis position="left">
                        <dxo-title text="USD $MM"></dxo-title>
                    </dxi-value-axis>
                    <dxo-argument-axis position="center">
                        <dxo-title text="Competitor"></dxo-title>
                    </dxo-argument-axis>
                    <dxo-legend verticalAlignment="top" [visible]="false" horizontalAlignment="center"
                        itemTextPosition="top">
                    </dxo-legend>
                    <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                        <dxo-format type="thousands" [precision]="1">
                        </dxo-format>
                    </dxo-tooltip>
                    <dxo-series-template nameField="primaryBusinessType"></dxo-series-template>
                    <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                </dx-chart>
            </dxi-item>
            <dxi-item class="marginT40">
                <dxi-location [row]="4" [col]="0"></dxi-location>
                <h5 style="text-align: center;">Europe</h5>
            </dxi-item>
            <dxi-item class="marginT40">
                <dxi-location [row]="4" [col]="1"></dxi-location>
                <h5 style="text-align: center;">Rest of World</h5>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="5" [col]="0"></dxi-location>
                <dx-chart [customizePoint]="customizePointRegional" palette="soft" class="width100" #euchart
                    id="euchart" [dataSource]="europeDataSource">
                    <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                    <dxo-common-series-settings argumentField="bigCompetitor" valueField="competitorInvestment"
                        type="stackedBar">
                    </dxo-common-series-settings>
                    <dxi-value-axis position="left">
                        <dxo-title text="USD $MM"></dxo-title>
                    </dxi-value-axis>
                    <dxo-argument-axis position="center">
                        <dxo-title text="Competitor"></dxo-title>
                    </dxo-argument-axis>
                    <dxo-legend verticalAlignment="top" [visible]="false" horizontalAlignment="center"
                        itemTextPosition="top">
                    </dxo-legend>
                    <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                        <dxo-format type="thousands" [precision]="1">
                        </dxo-format>
                    </dxo-tooltip>
                    <dxo-series-template nameField="primaryBusinessType"></dxo-series-template>
                    <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                </dx-chart>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="5" [col]="1"></dxi-location>
                <dx-chart [customizePoint]="customizePointRegional" palette="soft" class="width100" #rowchart
                    id="rowchart" [dataSource]="rowDataSource">
                    <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                    <dxo-common-series-settings argumentField="bigCompetitor" valueField="competitorInvestment"
                        type="stackedBar">
                    </dxo-common-series-settings>
                    <dxi-value-axis position="left">
                        <dxo-title text="USD $MM"></dxo-title>
                    </dxi-value-axis>
                    <dxo-argument-axis position="center">
                        <dxo-title text="Competitor"></dxo-title>
                    </dxo-argument-axis>
                    <dxo-legend verticalAlignment="top" [visible]="false" horizontalAlignment="center"
                        itemTextPosition="top">
                    </dxo-legend>
                    <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                        <dxo-format type="thousands" [precision]="1">
                        </dxo-format>
                    </dxo-tooltip>
                    <dxo-series-template nameField="primaryBusinessType"></dxo-series-template>
                    <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                </dx-chart>
            </dxi-item>
            <dxi-item class="marginT40">
                <dxi-location [row]="6" [col]="0" [colspan]="2"></dxi-location>
                <div class="btndiv">
                    <dx-button icon="export" text="Export Grids" type="default" class="exportgridbtn"
                        (onClick)="exportExcel($event)">
                    </dx-button>
                </div>
            </dxi-item>
            <dxi-item class="marginB10 grdmaxwidth">
                <dxi-location [row]="7" [col]="0" [colspan]="2"></dxi-location>
                <dx-pivot-grid #pivotGrid id="pivotGrid" [allowSortingBySummary]="true" [allowFiltering]="false"
                    (onCellPrepared)="onCellPrepared($event)" [showBorders]="true" [showColumnGrandTotals]="true"
                    [showRowGrandTotals]="true" [showRowTotals]="true" [showColumnTotals]="false"
                    [dataSource]="gridDataSOurce">
                    <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                    <dxo-scrolling mode="virtual"></dxo-scrolling>
                    <dxo-field-panel [showDataFields]="false" [showRowFields]="true" [showColumnFields]="false"
                        [showFilterFields]="false" [allowFieldDragging]="false" [visible]="true">
                    </dxo-field-panel>
                </dx-pivot-grid>
            </dxi-item>
        </dx-responsive-box>
    </div>
</div>